<template>
  <v-card flat class="pa-2">
    <v-row>
      <v-col v-for="card in value.cart" :key="card.id" cols="12" md="6" lg="4">
        <v-card>
          <v-img
            :src="card.picture ? `/media/images/insurance/${card.picture}` : ''"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="200px"
          >
            <v-card-title v-text="card.name"></v-card-title>
          </v-img>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green" outlined class="w-100">
              <v-icon>mdi-plus</v-icon>
              ثبت بیمه
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "insuranceCart",
  props: { value: [Object] },
  data() {
    return {
      cards: [
        {
          title: "Pre-fab homes",
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          flex: 12,
        },
        {
          title: "Favorite road trips",
          src: "https://cdn.vuetifyjs.com/images/cards/road.jpg",
          flex: 6,
        },
        {
          title: "Best airlines",
          src: "https://cdn.vuetifyjs.com/images/cards/plane.jpg",
          flex: 6,
        },
      ],
    };
  },

  mounted() {
    console.log("->", this.value);
  },
};
</script>

<style></style>
